import { dictionaryApi } from './dictionaryClient';

export type SamastaWord = {
  id: number;
  subantaId: number;
  order: number;
  subantaWordId?: number | null;
  tingantaWordId?: number | null;
};

export type CreateSamastaWordBody =
  | { subantaId: number; order: number; subantaWordId: number }
  | { subantaId: number; order: number; tingantaWordId: number };

export type PatchSamastaWordBody = Partial<{
  order: number;
  subantaWordId: number | null;
  tingantaWordId: number | null;
  subantaId: number;
}>;

function normalizeList(data: unknown): SamastaWord[] {
  if (Array.isArray(data)) return data as SamastaWord[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: SamastaWord[] }).data;
  }
  return [];
}

export async function listSamastaWords(): Promise<SamastaWord[]> {
  const res = await dictionaryApi.get<unknown>('/samasta-words');
  return normalizeList(res.data);
}

export async function getSamastaWord(id: number): Promise<SamastaWord> {
  const res = await dictionaryApi.get<SamastaWord>(`/samasta-words/${id}`);
  return res.data;
}

export async function createSamastaWord(body: CreateSamastaWordBody): Promise<SamastaWord> {
  const res = await dictionaryApi.post<SamastaWord>('/samasta-words', body);
  return res.data;
}

export async function updateSamastaWord(
  id: number,
  body: PatchSamastaWordBody
): Promise<SamastaWord> {
  const res = await dictionaryApi.patch<SamastaWord>(`/samasta-words/${id}`, body);
  return res.data;
}

export async function deleteSamastaWord(id: number): Promise<void> {
  await dictionaryApi.delete(`/samasta-words/${id}`);
}
